import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import ReducerConstants from '../../../_shared/constants/reducers';

const setSseConnectionStatus = (state, action: PayloadAction<any>) => ({
  ...state,
  error: action.payload,
  isConnected: false
});

const clear = (state, action: PayloadAction<any>) => ({
  ...state,
  error: null,
  isConnected: true
});

export const initialState = { isConnected: true };

export const sseConnectionSlice = createSlice({
  name: ReducerConstants.SSE_CONNECTION_STATUS,
  initialState,
  reducers: {
    clear,
    setSseConnectionStatus
  }
});

export default sseConnectionSlice.reducer;
